export const MODAL_OPEN = 'modal/MODAL_OPEN';
export const MODAL_CLOSE = 'modal/MODAL_CLOSE';